import { Box } from '@mui/system';
import { useEffect, useState } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { CommonDataState } from 'state/commonState';
import cn from 'classnames';
import { Control, UseFormSetValue } from 'react-hook-form';
import { Crop } from '@crops';
import pannelState from 'state/rightPannelState';
import CustomTab from './CustomTab';
import AiReportContainer from './aiReport/AiReportContainer';


type Props = {
  control: Control<Crop.FormData, any>;
  setValue: UseFormSetValue<Crop.FormData>;
  data: {
    values?: Crop.FormData;
    aiStat?: Crop.TStat[];
    aiDetailList?: Crop.TAiListResponse;
  };
  onSubmit: any;
};

const RightPannel = ({ control, data, setValue }: Props) => {
  const { sgg, legend } = useRecoilValue(CommonDataState);
  const setResultLegend = useSetRecoilState(CommonDataState);

  const [pannel, setPannel] = useRecoilState(pannelState);

  const [text, setText] = useState({
    location: '전체', //위치
    cropNm: '전체', // 작물
  });

  useEffect(() => {
    if (!data.values) return;

    // 조회 결과에 따른 지도 범례를 셋팅하기 위함.
    setResultLegend((prev) => ({ ...prev, resultLegend: data.aiStat }));

    const values = data.values;
    console.log('values : ', values);
    const ctpv = values.ctpvNm? values.ctpvNm : '전체';
    const si = values.sggNm? values.sggNm : '전체';
    const emd = values.emdNm? values.emdNm : '';
    // 시
    // const si = values.sggCd === '0' ? '전체' : sgg.filter((i) => i.sgg_cd === values.sggCd)[0].sgg_nm;
    // 동
    // const em = values.emdCd === '0' ? '' : emd.filter((i) => i.emd_cd === values.emdCd)[0].emd_nm;
    // 작물명
    const cropNm =
      values.treeKindCd && values.treeKindCd === '0'
        ? '전체'
        : legend.filter((i) => i.cmmn_cd_id === values.treeKindCd)[0].cmmn_cd_abrv_nm;

    setText((prev) => ({
      ...prev,
      location: `${ctpv} ${si} ${emd}`,
      cropNm: cropNm,
    }));
  }, [data]);

  const pannelClose = () => {
    setPannel((prev) => ({
      ...prev,
      status: {
        ...prev.status,
        isOpen: false,
      },
    }));
  };

  const pannelFold = () => {
    setPannel((prev) => ({
      ...prev,
      status: {
        ...prev.status,
        isFold: !prev.status.isFold,
      },
    }));
  };

  return (
    <Box className={cn('mapInfoArea', { on: pannel.status.isOpen, hide: pannel.status.isFold })}>
      <button
        type="button"
        className="mapInfoBtn"
        onClick={pannelFold}
      ></button>
      <Box className="mapInfoBox">
        <div className="mapInfoTitArea">
          <div className="mapInfoTitItem">
            <span className="cChipFill00">위치</span>
            {text.location}
          </div>
          <div className="mapInfoTitItem">
            <span className="cChipFill03">작물</span>
            {text.cropNm}
          </div>
          <button
            type="button"
            className="mapInfoCloseBtn"
            onClick={pannelClose}
          >
            <span>정보창 닫기 버튼</span>
          </button>
        </div>


        {/*  AI 분석결과 탭 */}
        <CustomTab
          value={pannel.status.currentPage}
          index="ai"
        >
          {/* {!pannel.status.aiDetail.isOpen && <AiReportContainer control={control} />} */}

          <AiReportContainer
            control={control}
            className={cn({ hide: pannel.status.aiDetail.isOpen })}
          />
        </CustomTab>

       
        <button
          type="button"
          className="mapInfoGotopBtn"
          onClick={() => document.getElementsByClassName('mapInfoConArea')[0].scrollTo({ top: 0 })}
        >
          <span>정보창 맨위로가기 버튼</span>
        </button>
      </Box>
    
     
    </Box>
  );
};

export default RightPannel;
